<template>
  <div class="journal-wrapper">
    <common-top :seconTitle="seconTitle"></common-top>
    <div class="journal-list">
      <div class="journal-list-search">
        <div class="jour-list-item">筛选:</div>
        <div class="select-item">
          <i class="icon-down lMar10"></i>
          <select name id v-model="year" @change="getList()">
            <option value>全部</option>
            <option :value="item.value" v-for="(item,index) in yearList" :key="index">{{item.lable}}</option>
          </select>
        </div>
        <div class="select-item">
          <i class="icon-down lMar10"></i>
          <select name id v-model="month" @change="getList()">
            <option value>全部</option>
            <option
              :value="item.value"
              v-for="(item,index) in monthList"
              :key="index"
            >{{item.lable}}</option>
          </select>
        </div>
      </div>
      <div class="journal-list-center">
        <div class="journal-four-list" v-for="(item,index) in journalList" :key="'jon'+index">
          <div
            class="journal-item"
            v-for="(item_2,index_2) in item"
            :key="'journal'+index_2"
            @click="toPage({name:'JournalDetail',query:{id:item_2.id,year:item_2.year,num:item_2.num}})"
          >
            <div class="journal-item-title">第{{item_2.num}}期</div>
            <div class="journal-item-text">{{item_2.publish_date}}</div>
          </div>
        </div>
      </div>
    </div>
    <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
  </div>
</template>

<script>
import { getYears, getMonths } from "@/filter";
import ModelPage from "@/components/views/common/ModelPage";
import commonTop from "./commonTop";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      seconTitle: "全部期刊",
      yearList: [],
      monthList: [],
      year: "",
      page: 1,
      count: 12,
      month: "",
      ariList: [],
      journalList: []
    };
  },
  mounted() {
    this.yearList = getYears(); //获取年份   不传值表示  从今年到1990
    // this.year = this.yearList[0].value;
    this.monthList = getMonths();
    // this.month = this.monthList[0].value;
    this.getJournalList();
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    getJournalList() {
      const params = {
        year: this.year,
        month: this.month,
        page: this.page,
        count: this.count
      };
      userApi.getjournallistList(params).then(res => {
        this.ariList = res.data;
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "JournalDetail",
            query: { id: this.ariList.list[0].id, year: this.ariList.list[0].year, num: this.ariList.list[0].num }
          });
        }
        var result = [];
        var chunk = 4; //每4个分一组
        for (var i = 0, j = res.data.list.length; i < j; i += chunk) {
          result.push(res.data.list.slice(i, i + chunk));
        }
        this.journalList = result;
      });
    },
    getList() {
      this.getJournalList();
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getJournalList();
      // 重新加载列表
    }
  },
  components: {
    ModelPage,
    commonTop
  }
};
</script>

<style scoped>
.journal-list {
  padding: 70px 0 20px;
  box-sizing: border-box;
  width: 100%;
  background: #edf1f4;
  border-radius: 10px;
  border: 1px solid #edf1f4;
  position: relative;
  margin-bottom: 30px;
}
.journal-list-center {
  width: 100%;
  background: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
}
.journal-list-search {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  display: flex;
  font-size: 18px;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.journal-four-list {
  width: 100%;
  height: 315px;
  position: relative;
  display: flex;
  margin-bottom: 30px;
  /* box-shadow: 0 0 10px #E6ECF2; */
}
.journal-four-list::before {
  content: " ";
  position: absolute;
  width: 100%;
  height: 50px;
  bottom: 30px;
  left: 0;
  background: url(/static/img/book.png) no-repeat center center;
  background-size: 1180px 50px;
  z-index:102;
}
.journal-four-list::after {
  content: " ";
  position: absolute;
  width: 100%;
  height: 86px;
  bottom: -20px;
  left: 0;
  background: url(/static/img/bookshadow.png) no-repeat center center;
  background-size: 1141px 50px;
  z-index: 101;
}
.journal-item {
  width: 25%;
  height: 250px;
  background: url("/static/img/bookitem.png") no-repeat center center;
  background-size: 189px 100%;
  position: relative;
  cursor: pointer;
}
.journal-item-title {
  font-size: 22px;
  color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 65px;
  text-align: center;
}
.journal-item-text {
  font-size: 14px;
  color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 44px;
  text-align: center;
}
.journal-wrapper {
  width: 1240px;
  margin: 0 auto;
}
.journal-top {
  overflow: hidden;
}
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
.padd {
  padding: 0 4px;
}
.search-wrapper {
  width: 310px;
  height: 40px;
  margin-right: 30px;
  background: rgba(237, 241, 244, 1);
  border: 1px solid rgba(220, 227, 233, 1);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
  float: left;
}
.search-btn {
  width: 25px;
  height: 26px;
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
}
.search-input::placeholder {
  color: #a2a8b8;
}
.search-input {
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  background: rgba(237, 241, 244, 1);
}
.select-item {
  width: 155px;
  height: 40px;
  margin: 15px;
  line-height: 40px;
  position: relative;
}
.select-item select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.select-item select::-ms-expand {
  display: none;
}
.select-item select {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: none;
  outline: none;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 10px;
  color: #000;
  font-size: 18px;
}
.icon-down {
  position: absolute;
  top: 8px;
  right: 8px;
  display: block;
  width: 15px;
  height: 24px;
  background-size: 15px 24px;
  background: url("/static/img/select.png") no-repeat center;
}
</style>




// WEBPACK FOOTER //
// src/components/views/Journal/list.vue